import './navigation'
import './banner'
import './form-thank-you'
// import './scroll-expand';
import './calendar-tab'
import './accordion'
import './calendar-messaging'
import './calendar-one-whitman'
import './slider'
import './community-data-slider'
import './video'
import './video-slider'
import './video-w-chapters'
import './inspections'
import './comm-data-reports-archive'
import './latest-news-slider'
import './one-whitman-slider'
import './card-game-popup'
import './conversation-starters'
import './tooltip'
import './public-archive'
import './thrive-locally'
import './thrive-locally-lotties'
import './hero-videos'
import './data-dashboard'
import './notifiable-conditions'

window.addEventListener('DOMContentLoaded', () => {
	// AOS
	AOS.init({
		duration: 600,
		delay: 100,
		once: true,
	})
})
